import { MUILab } from 'ci-esi-web-shared';
import { ReactNode } from 'react';

export interface TabPanelProps {
  children: ReactNode;
  value: string;
}

const tabPanelBaseSx = {
  width: 'calc(100% - 24px)',
  margin: 0,
  padding: 0,
  display: 'flex',
  position: 'absolute' as const,
  top: 48,
  left: 24,
  visibility: 'hidden' as const,
};

export const TabPanel = ({ children, value: id }: TabPanelProps) => {
  const context = MUILab.useTabContext();

  if (context === null) {
    throw new TypeError('No Tab Context provided');
  }

  const tabId = context.value;

  return (
    <div
      style={{
        ...tabPanelBaseSx,
        visibility: id === tabId ? 'visible' : 'hidden',
      }}
    >
      {children}
    </div>
  );
};
